import { ref } from 'vue'

// Dark mode is a single root-level `.dark` class (PrimeVue's darkModeSelector + Tailwind's
// dark variant) persisted in localStorage. With no stored choice we follow the OS preference.
// The composable shares one reactive flag across the app.
const stored = localStorage.getItem('theme')
const isDark = ref(stored ? stored === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches)

const apply = () => {
    document.documentElement.classList.toggle('dark', isDark.value)
}

apply()

export const useDarkMode = () => {
    const toggleDark = () => {
        isDark.value = !isDark.value
        localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
        apply()
    }

    return { isDark, toggleDark }
}
